// Festivos oficiales por país para el SLA (Etapa 1c). Se calculan por año a partir de la ley
// de cada país; los días que se decretan año con año (puentes turísticos, días de asueto
// extra) se agregan a mano en la configuración de la empresa.
//  MX: Ley Federal del Trabajo, art. 74 (descanso obligatorio).
//  CO: Ley 51 de 1983 ("Ley Emiliani"): varios festivos pasan al lunes siguiente.
//  AR: Ley 27.399: inamovibles, trasladables y Carnaval.
//  JM: Holidays (Public General) Act: si cae en domingo se recorre al lunes.
export const COUNTRIES = ['MX', 'CO', 'AR', 'JM'];
export const COUNTRY_INFO = {
    MX: { name: 'México', timezone: 'America/Mexico_City' },
    CO: { name: 'Colombia', timezone: 'America/Bogota' },
    AR: { name: 'Argentina', timezone: 'America/Argentina/Buenos_Aires' },
    JM: { name: 'Jamaica', timezone: 'America/Jamaica' }
};
export const isCountry = (v) => typeof v === 'string' && COUNTRIES.includes(v);
const key = (d) => d.toISOString().slice(0, 10);
const day = (y, m, d) => new Date(Date.UTC(y, m - 1, d));
const plus = (d, n) => new Date(d.getTime() + n * 86_400_000);
const dow = (d) => d.getUTCDay();
/** Domingo de Pascua (algoritmo anónimo gregoriano). */
export function easterSunday(y) {
    const a = y % 19, b = Math.floor(y / 100), c = y % 100;
    const d = Math.floor(b / 4), e = b % 4, f = Math.floor((b + 8) / 25), g = Math.floor((b - f + 1) / 3);
    const h = (19 * a + b - d - g + 15) % 30, i = Math.floor(c / 4), k = c % 4;
    const l = (32 + 2 * e + 2 * i - h - k) % 7, m = Math.floor((a + 11 * h + 22 * l) / 451);
    const month = Math.floor((h + l - 7 * m + 114) / 31), dd = ((h + l - 7 * m + 114) % 31) + 1;
    return day(y, month, dd);
}
/** n-ésimo lunes (o día de la semana `wd`) del mes. */
function nthWeekday(y, m, wd, n) {
    const first = day(y, m, 1);
    return plus(first, ((wd - dow(first) + 7) % 7) + (n - 1) * 7);
}
/** Pasa al lunes siguiente si no cae en lunes (Ley Emiliani). */
const nextMonday = (d) => (dow(d) === 1 ? d : plus(d, (8 - dow(d)) % 7));
/** Argentina, trasladables: mar/mié → lunes anterior; jue/vie → lunes siguiente. */
function argentinaMovable(d) {
    const w = dow(d);
    if (w === 2 || w === 3)
        return plus(d, 1 - w);
    if (w === 4 || w === 5)
        return plus(d, 8 - w);
    return d;
}
function mexico(y) {
    const list = [
        { date: key(day(y, 1, 1)), name: 'Año Nuevo' },
        { date: key(nthWeekday(y, 2, 1, 1)), name: 'Día de la Constitución' },
        { date: key(nthWeekday(y, 3, 1, 3)), name: 'Natalicio de Benito Juárez' },
        { date: key(day(y, 5, 1)), name: 'Día del Trabajo' },
        { date: key(day(y, 9, 16)), name: 'Día de la Independencia' },
        { date: key(nthWeekday(y, 11, 1, 3)), name: 'Día de la Revolución' },
        { date: key(day(y, 12, 25)), name: 'Navidad' }
    ];
    // Transmisión del Poder Ejecutivo Federal: 1 de octubre cada seis años (2024, 2030…).
    if (y >= 2024 && (y - 2024) % 6 === 0)
        list.push({ date: key(day(y, 10, 1)), name: 'Transmisión del Poder Ejecutivo' });
    return list;
}
function colombia(y) {
    const e = easterSunday(y);
    return [
        { date: key(day(y, 1, 1)), name: 'Año Nuevo' },
        { date: key(nextMonday(day(y, 1, 6))), name: 'Reyes Magos' },
        { date: key(nextMonday(day(y, 3, 19))), name: 'San José' },
        { date: key(plus(e, -3)), name: 'Jueves Santo' },
        { date: key(plus(e, -2)), name: 'Viernes Santo' },
        { date: key(day(y, 5, 1)), name: 'Día del Trabajo' },
        { date: key(plus(e, 43)), name: 'Ascensión del Señor' },
        { date: key(plus(e, 64)), name: 'Corpus Christi' },
        { date: key(plus(e, 71)), name: 'Sagrado Corazón' },
        { date: key(nextMonday(day(y, 6, 29))), name: 'San Pedro y San Pablo' },
        { date: key(day(y, 7, 20)), name: 'Día de la Independencia' },
        { date: key(day(y, 8, 7)), name: 'Batalla de Boyacá' },
        { date: key(nextMonday(day(y, 8, 15))), name: 'Asunción de la Virgen' },
        { date: key(nextMonday(day(y, 10, 12))), name: 'Día de la Raza' },
        { date: key(nextMonday(day(y, 11, 1))), name: 'Todos los Santos' },
        { date: key(nextMonday(day(y, 11, 11))), name: 'Independencia de Cartagena' },
        { date: key(day(y, 12, 8)), name: 'Inmaculada Concepción' },
        { date: key(day(y, 12, 25)), name: 'Navidad' }
    ];
}
function argentina(y) {
    const e = easterSunday(y);
    return [
        { date: key(day(y, 1, 1)), name: 'Año Nuevo' },
        { date: key(plus(e, -48)), name: 'Carnaval' },
        { date: key(plus(e, -47)), name: 'Carnaval' },
        { date: key(day(y, 3, 24)), name: 'Día de la Memoria' },
        { date: key(day(y, 4, 2)), name: 'Día del Veterano y de los Caídos en Malvinas' },
        { date: key(plus(e, -2)), name: 'Viernes Santo' },
        { date: key(day(y, 5, 1)), name: 'Día del Trabajador' },
        { date: key(day(y, 5, 25)), name: 'Revolución de Mayo' },
        { date: key(argentinaMovable(day(y, 6, 17))), name: 'Paso a la Inmortalidad de Güemes' },
        { date: key(day(y, 6, 20)), name: 'Día de la Bandera' },
        { date: key(day(y, 7, 9)), name: 'Día de la Independencia' },
        { date: key(argentinaMovable(day(y, 8, 17))), name: 'Paso a la Inmortalidad de San Martín' },
        { date: key(argentinaMovable(day(y, 10, 12))), name: 'Día del Respeto a la Diversidad Cultural' },
        { date: key(argentinaMovable(day(y, 11, 20))), name: 'Día de la Soberanía Nacional' },
        { date: key(day(y, 12, 8)), name: 'Inmaculada Concepción' },
        { date: key(day(y, 12, 25)), name: 'Navidad' }
    ];
}
function jamaica(y) {
    const e = easterSunday(y);
    const fixed = [
        [1, 1, "New Year's Day"], [5, 23, 'Labour Day'], [8, 1, 'Emancipation Day'],
        [8, 6, 'Independence Day'], [12, 25, 'Christmas Day'], [12, 26, 'Boxing Day']
    ];
    const taken = new Set();
    const list = [
        { date: key(plus(e, -46)), name: 'Ash Wednesday' },
        { date: key(plus(e, -2)), name: 'Good Friday' },
        { date: key(plus(e, 1)), name: 'Easter Monday' },
        { date: key(nthWeekday(y, 10, 1, 3)), name: 'National Heroes Day' }
    ];
    for (const [m, d, name] of fixed) {
        let date = day(y, m, d);
        if (dow(date) === 0)
            date = plus(date, 1);
        while (taken.has(key(date)))
            date = plus(date, 1); // Navidad en domingo empuja Boxing Day al martes
        taken.add(key(date));
        list.push({ date: key(date), name });
    }
    return list;
}
const BUILDERS = { MX: mexico, CO: colombia, AR: argentina, JM: jamaica };
const cache = new Map();
/** Festivos oficiales de un país en un año, ordenados por fecha. */
export function holidaysFor(country, year) {
    const k = `${country}:${year}`;
    let list = cache.get(k);
    if (!list) {
        list = BUILDERS[country](year).sort((a, b) => a.date.localeCompare(b.date));
        cache.set(k, list);
    }
    return list;
}
const sets = new Map();
/** ¿El día local `date` (YYYY-MM-DD) es festivo oficial del país? */
export function isOfficialHoliday(country, date) {
    const k = `${country}:${date.slice(0, 4)}`;
    let s = sets.get(k);
    if (!s) {
        s = new Set(holidaysFor(country, Number(date.slice(0, 4))).map(h => h.date));
        sets.set(k, s);
    }
    return s.has(date);
}
/** Próximos festivos (oficiales y agregados a mano) desde una fecha. */
export function upcomingHolidays(country, from, extra = [], limit = 8) {
    const today = key(from);
    const y = from.getUTCFullYear();
    return [...holidaysFor(country, y), ...holidaysFor(country, y + 1), ...extra]
        .filter(h => h.date >= today)
        .sort((a, b) => a.date.localeCompare(b.date))
        .slice(0, limit);
}
//# sourceMappingURL=holidays.js.map